module.exports = __webpack_public_path__ + "img/confetty.cf26841d.webp";